import { render, staticRenderFns } from "./ShareholderReduction.vue?vue&type=template&id=983d07dc&scoped=true"
import script from "./ShareholderReduction.vue?vue&type=script&lang=js"
export * from "./ShareholderReduction.vue?vue&type=script&lang=js"
import style0 from "./ShareholderReduction.vue?vue&type=style&index=0&id=983d07dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "983d07dc",
  null
  
)

export default component.exports